import * as React from 'react';
import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import { getApplicationPermissions, getUserProfile, getUserPortalRoles, launch } from '../ApiUtils/ApiUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import AdminSidebarSubmenu from './Applications/AdminSidebarSubmenu';
import { shortcutsConfig } from './../ShortcutsConfig';
import ApplicationSubmenu from './Applications/ApplicationSubmenu';
import { faLightbulb, faChartArea, faHeadset, faHome, faSlidersH, faTools, faUserCog, faUserHeadset, faBrain, faGraduationCap, faRocket } from '@fortawesome/pro-solid-svg-icons';

const PortalHomeAppTemplate: Application = {
    order: 0,
    display: true,
    icon: <FontAwesomeIcon icon={faHome} size="lg" className="me-1" fixedWidth />,
    name: 'Home',
    bottomSeparator:true,
    displayName: 'Home',
    type: 'PortalHome',
    description: <div className="mt-3 text-muted"></div>,
    launcher: '/console',
    onLaunch: (self, dispatch) => {
        self.launcher && dispatch(push(self.launcher));
    }
}

const PortalTrainingAppTemplate: Application = {
    order: 9999,
    display: true,
    displayName: "Training",
    name: 'Training',
    type: 'PortalTraining',
    description: <div className="mt-3 text-muted">Training</div>,
    launcher: 'https://gdslink.bridgeapp.com/login',
}

const ApplicationTemplates: Application[] = [PortalHomeAppTemplate,
    {
        order: 1,
        display: true,
        displayName: "Decision Studio",
        name: 'Decision Studio',
        type: 'DecisionStudio',
        group: 'Decisioning Solutions',
        groupIcon: <FontAwesomeIcon icon={faLightbulb} size="lg" className="me-1" fixedWidth />,
        urlType: 'Decision Studio',
        shortcutId: '1', // do not modify
        description: <div className="mt-3 text-muted">Decision Studio</div>,
        onInitialized: (self) => {
            self.shortcuts = <ApplicationSubmenu application={self} />;
            self.sidebarSubMenu = <ApplicationSubmenu className="sidebar-lima-submenu" buttonClassName="btn btn-sidebar" application={self}
                buttonConfig={shortcutsConfig.filter(button => button.applicationType === 'DecisionStudio')} hasUrlList={true} />;
        }
    }, {
        order: 2,
        display: true,
        displayName: "Case Manager",
        name: 'Case Manager',
        type: 'CaseManager',
        group: 'Decisioning Solutions',
        groupIcon: <FontAwesomeIcon icon={faLightbulb} size="lg" className="me-1" fixedWidth />,
        urlType: 'Case Manager',
        shortcutId: '2', // do not modify
        description: <div className="mt-3 text-muted">Case Manager</div>,
        onInitialized: (self) => {
            self.shortcuts = <ApplicationSubmenu application={self} />;
            self.sidebarSubMenu = <ApplicationSubmenu className="sidebar-lima-submenu" buttonClassName="btn btn-sidebar" application={self}
                buttonConfig={shortcutsConfig.filter(button => button.applicationType === 'CaseManager')} hasUrlList={true} />;
        },
        onLaunch: (self, dispatch) => {
            self.launcher && dispatch(push(self.launcher));
        }
    }, {
        order: 3,
        display: true,
        displayName: "Data Exchange",
        name: 'Data Exchange',
        type: 'DataExchange',
        group: 'Decisioning Solutions',
        groupIcon: <FontAwesomeIcon icon={faLightbulb} size="lg" className="me-1" fixedWidth />,
        shortcutId: '3', // do not modify
        description: <div className="mt-3 text-muted">Data Exchange</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Data Exchange [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 4,
        display: true,
        displayName: "Policy Monitoring",
        name: 'Policy Monitoring',
        type: 'PolicyMonitoring',
        group: 'Data & Intelligence',
        groupIcon: <FontAwesomeIcon icon={faBrain} size="lg" className="me-1" fixedWidth />,
        shortcutId: '4', // do not modify
        description: <div className="mt-3 text-muted">Policy Monitoring</div>,
        launcher: "/data-intelligence/policy-monitoring",
        onLaunch: (self, dispatch) => {
            self.launcher = "/data-intelligence/policy-monitoring";
            self.launcher && dispatch(push(self.launcher));
        }
    }, {
        order: 5,
        display: true,
        displayName: "Model Monitoring",
        name: 'Model Monitoring',
        type: 'ModelMonitoring',
        group: 'Data & Intelligence',
        groupIcon: <FontAwesomeIcon icon={faBrain} size="lg" className="me-1" fixedWidth />,
        shortcutId: '5', // do not modify
        description: <div className="mt-3 text-muted">Model Monitoring</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Model Monitoring [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 6,
        display: true,
        displayName: "Policy Optimization",
        name: 'Policy Optimization',
        type: 'PolicyOptimization',
        group: 'Data & Intelligence',
        groupIcon: <FontAwesomeIcon icon={faBrain} size="lg" className="me-1" fixedWidth />,
        shortcutId: '6', // do not modify
        description: <div className="mt-3 text-muted">Policy Optimization</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Policy Optimization [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 7,
        display: true,
        displayName: "Systems Monitoring",
        name: 'Systems Monitoring',
        type: 'SystemsMonitoring',
        group: 'Configuration Details',
        groupIcon: <FontAwesomeIcon icon={faSlidersH} size="lg" className="me-1" fixedWidth />,
        shortcutId: '7', // do not modify
        description: <div className="mt-3 text-muted">Systems Monitoring</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Systems Monitoring [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 8,
        display: true,
        displayName: "Change Order Tracking",
        name: 'Change Order Tracking',
        type: 'ChangeOrderTracking',
        group: 'Configuration Details',
        groupIcon: <FontAwesomeIcon icon={faSlidersH} size="lg" className="me-1" fixedWidth />,
        shortcutId: '8', // do not modify
        description: <div className="mt-3 text-muted">Change Order Tracking</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Change Order Tracking [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 9,
        display: true,
        displayName: "Licensing and Billing Details",
        name: 'Licensing and Billing Details',
        type: 'LicensingAndBillingDetails',
        group: 'Configuration Details',
        groupIcon: <FontAwesomeIcon icon={faSlidersH} size="lg" className="me-1" fixedWidth />,
        shortcutId: '9', // do not modify
        description: <div className="mt-3 text-muted">Licensing and Billing Details</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Licensing and Billing Details [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 10,
        display: true,
        displayName: "Release Notes",
        name: 'Release Notes',
        type: 'ReleaseNotes',
        group: 'Configuration Details',
        groupIcon: <FontAwesomeIcon icon={faSlidersH} size="lg" className="me-1" fixedWidth />,
        shortcutId: '10', // do not modify
        description: <div className="mt-3 text-muted">Release Notes</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Release Notes [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 11,
        display: false,
        displayName: "Chat",
        name: 'Chat',
        type: 'Chat',
        group: 'Support',
        groupIcon: <FontAwesomeIcon icon={faHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '11', // do not modify
        description: <div className="mt-3 text-muted">Chat</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Chat [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 12,
        display: true,
        displayName: "Email",
        name: 'Email',
        type: 'Email',
        group: 'Support',
        groupIcon: <FontAwesomeIcon icon={faHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '12', // do not modify
        description: <div className="mt-3 text-muted">Email</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Email [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 13,
        display: true,
        displayName: "Request New Feature",
        name: 'Request New Feature',
        type: 'RequestNewFeature',
        group: 'Support',
        groupIcon: <FontAwesomeIcon icon={faHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '13', // do not modify
        description: <div className="mt-3 text-muted">Request New Feature</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Request New Feature [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 14,
        display: true,
        displayName: "Documentation",
        name: 'Documentation',
        type: 'Documentation',
        group: 'Learning Center',
        groupIcon: <FontAwesomeIcon icon={faGraduationCap} size="lg" className="me-1" fixedWidth />,
        shortcutId: '14', // do not modify
        description: <div className="mt-3 text-muted">Documentation</div>,
        launcher: "api/Application/launch?app=Documentation",
        onLaunch: (self, dispatch) => {
            dispatch({ type: 'UPDATE_LAUNCH_STATUS', payload: { isLaunching: true, application: self } });
            self.launcher = "api/Application/launch?app=Documentation";
            self.launcher && launch(self.launcher).then(response => {
                if (response.data.success) {
                    window.open(`https://modellica.document360.io/jwt/authorize?code=${response.data.code}`);
                }
                dispatch({ type: 'UPDATE_LAUNCH_STATUS', payload: { isLaunching: false, application: self } });
            });
        }
    }, {
        order: 15,
        display: true,
        displayName: "GDS Link University",
        name: 'GDS Link University',
        type: 'GdsLinkUniversity',
        group: 'Learning Center',
        groupIcon: <FontAwesomeIcon icon={faGraduationCap} size="lg" className="me-1" fixedWidth />,
        shortcutId: '15', // do not modify
        description: <div className="mt-3 text-muted">GDS Link University</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>GDS Link University [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 16,
        display: true,
        displayName: "User Forum",
        name: 'User Forum',
        type: 'UserForum',
        group: 'Learning Center',
        groupIcon: <FontAwesomeIcon icon={faGraduationCap} size="lg" className="me-1" fixedWidth />,
        shortcutId: '16', // do not modify
        description: <div className="mt-3 text-muted">User Forum</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>User Forum [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 17,
        display: true,
        displayName: "Web DV",
        name: 'Web DV',
        type: 'WebDv',
        group: 'Tools',
        groupIcon: <FontAwesomeIcon icon={faTools} size="lg" className="me-1" fixedWidth />,
        shortcutId: '17', // do not modify
        description: <div className="mt-3 text-muted">Web DV</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Web DV [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 18,
        display: true,
        displayName: "Case Manager",
        name: 'Case Manager',
        type: 'CmTools',
        group: 'Tools',
        groupIcon: <FontAwesomeIcon icon={faTools} size="lg" className="me-1" fixedWidth />,
        shortcutId: '18', // do not modify
        description: <div className="mt-3 text-muted">Case Manager</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Case Manager [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 19,
        display: true,
        displayName: "Digital Onboarding",
        name: 'Digital Onboarding',
        type: 'DigitalOnboarding',
        group: 'Tools',
        groupIcon: <FontAwesomeIcon icon={faTools} size="lg" className="me-1" fixedWidth />,
        shortcutId: '19', // do not modify
        description: <div className="mt-3 text-muted">Digital Onboarding</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Digital Onboarding [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 20,
        display: true,
        displayName: "Real-time Systems Monitoring",
        name: 'Real-time Systems Monitoring',
        type: 'RtsMonitoring',
        group: 'Monitoring',
        groupIcon: <FontAwesomeIcon icon={faChartArea} size="lg" className="me-1" fixedWidth />,
        shortcutId: '20', // do not modify
        description: <div className="mt-3 text-muted">Real-time Systems Monitoring</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Real-time Systems Monitoring [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 21,
        display: true,
        displayName: "Analytics",
        name: 'Analytics',
        type: 'Analytics',
        group: 'Monitoring',
        groupIcon: <FontAwesomeIcon icon={faChartArea} size="lg" className="me-1" fixedWidth />,
        shortcutId: '21', // do not modify
        description: <div className="mt-3 text-muted">Analytics</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Analytics [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 22,
        display: true,
        displayName: "Updates",
        name: 'Updates',
        type: 'Updates',
        group: 'Implementation',
        groupIcon: <FontAwesomeIcon icon={faRocket} size="lg" className="me-1" fixedWidth />,
        shortcutId: '22', // do not modify
        description: <div className="mt-3 text-muted">Updates</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Updates [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 23,
        display: true,
        displayName: "Change Orders",
        name: 'Change Orders',
        type: 'ChangeOrders',
        group: 'Implementation',
        groupIcon: <FontAwesomeIcon icon={faRocket} size="lg" className="me-1" fixedWidth />,
        shortcutId: '23', // do not modify
        description: <div className="mt-3 text-muted">Change Orders</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Change Orders [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 24,
        display: true,
        displayName: "Tracking",
        name: 'Tracking',
        type: 'Tracking',
        group: 'Implementation',
        groupIcon: <FontAwesomeIcon icon={faRocket} size="lg" className="me-1" fixedWidth />,
        shortcutId: '24', // do not modify
        description: <div className="mt-3 text-muted">Tracking</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Tracking [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 25,
        display: true,
        displayName: "UI/UX Templates",
        name: 'UI/UX Templates',
        type: 'UiUxTemplates',
        group: 'Implementation',
        groupIcon: <FontAwesomeIcon icon={faRocket} size="lg" className="me-1" fixedWidth />,
        shortcutId: '25', // do not modify
        description: <div className="mt-3 text-muted">UI/UX Templates</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>UI/UX Templates [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 26,
        display: true,
        displayName: "Documentation",
        name: 'Documentation',
        type: 'DocsCs',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '26', // do not modify
        description: <div className="mt-3 text-muted">Documentation</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Documentation [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 27,
        display: true,
        displayName: "Product Support",
        name: 'Product Support',
        type: 'ProductSupport',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '27', // do not modify
        description: <div className="mt-3 text-muted">Product Support</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Product Support [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 28,
        display: true,
        displayName: "General Support",
        name: 'General Support',
        type: 'GeneralSupport',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '28', // do not modify
        description: <div className="mt-3 text-muted">General Support</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>General Support [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 29,
        display: true,
        displayName: "Chat Bot",
        name: 'Chat Bot',
        type: 'ChtBot',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '29', // do not modify
        description: <div className="mt-3 text-muted">Chat Bot</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Chat Bot [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 30,
        display: true,
        displayName: "Customer Satisfaction Survey",
        name: 'Customer Satisfaction Survey',
        type: 'CustomerSatisfactionSurvey',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '30', // do not modify
        description: <div className="mt-3 text-muted">Customer Satisfaction Survey</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Customer Satisfaction Survey [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 31,
        display: true,
        displayName: "Learning Center",
        name: 'Learning Center',
        type: 'LearningCenter',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '31', // do not modify
        description: <div className="mt-3 text-muted">Learning Center</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Learning Center [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 32,
        display: true,
        displayName: "Product Feature Request",
        name: 'Product Feature Request',
        type: 'ProductFeatureRequest',
        group: 'Customer Support',
        groupIcon: <FontAwesomeIcon icon={faUserHeadset} size="lg" className="me-1" fixedWidth />,
        shortcutId: '32', // do not modify
        description: <div className="mt-3 text-muted">Product Feature Request</div>,
        onInitialized: (self) => {
            if (self.environment && self.environment !== 'prod') {
                self.icon = <>Product Feature Request [{self.environment?.toUpperCase()}]</>
            }
        }
    }, {
        order: 9999,
        display: true,
        name: "",
        displayName: "?",
        type: 'defaultApp',
        description: <div className="mt-3 text-muted">Admin</div>,
    }, {
        order: 99999,
        display: true,
        topSeparator: true,
        icon: <FontAwesomeIcon icon={faUserCog} size="lg" className="me-1" fixedWidth />,
        name: 'Admin',
        displayName: "Admin",
        type: 'PortalAdmin',
        description: <div className="mt-3 text-muted">Admin</div>,
        onInitialized: (self) => {
            self.sidebarSubMenu = <AdminSidebarSubmenu application={self} isadmin={false} isroot={false} />;
        },
        onLaunch: (self, dispatch) => {
            self.launcher && dispatch(push(self.launcher));
        }
    }
];

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ConsoleState {
    applicationsState: {
        isLoading: boolean;
        applications: Application[];
        buttons: string[];
        currentCompany: CurrentCompany;
    },
    userProfileState: {
        isLoading: boolean;
        userProfile: UserProfile;
    }
    launchState: {
        isLaunching: boolean;
        application: string;
    }
}

export interface Application {
    order: number;
    icon?: React.ReactNode;
    display?: boolean;
    name: string;
    applicationFullName?: string;
    topSeparator?: boolean;
    bottomSeparator?: boolean;
    displayName?: string;
    type: string;
    group?: string;
    groupIcon?: React.ReactNode;
    urlType?: string;
    shortcutId?: string;
    environment?: string;
    launcher?: string;
    description?: React.ReactNode;
    shortcuts?: React.ReactNode;
    roles?: string[];
    sidebarSubMenu?: React.ReactNode;
    buttons?: string[];
    onInitialized?: (self: Application) => void;
    onLaunch?: (self: Application, dispatch: (action: KnownAction) => void) => void;
 }

export interface UserProfile {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    aspUserId: number;
}

export interface CurrentCompany {
    $id: string;
    domains: string;
    name: string;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface GetApplicationsAction {
    type: 'GET_APPLICATIONS';
}

interface UpdateApplicationsAction {
    type: 'UPDATE_APPLICATIONS';
    payload: Application[];
    shortcuts: string[];
}

interface UpdateLaunchStatusAction {
    type: 'UPDATE_LAUNCH_STATUS';
    payload: {
        isLaunching: boolean;
        application: Application;
    };
}

interface GetUserProfileAction {
    type: 'GET_USER_PROFILE';
}

interface UpdateUserProfileAction {
    type: 'UPDATE_USER_PROFILE';
    payload: UserProfile;
}

interface UpdateCurrentCompanyAction {
    type: 'UPDATE_CURRENT_COMPANY';
    payload: CurrentCompany;
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = GetApplicationsAction | UpdateApplicationsAction | UpdateLaunchStatusAction | CallHistoryMethodAction | GetUserProfileAction | UpdateUserProfileAction | UpdateCurrentCompanyAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    getApplications: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        const appState = getState();
        if (appState && !(appState.console?.applicationsState.isLoading ?? false)) {
            getApplicationPermissions().then((response: { applications: Application[] }) => {
                let apps: Application[] = [];
                let buttons: string[] = [];
                var homeApp = ApplicationTemplates.find(app => app.type === PortalHomeAppTemplate.type);
                var trainingApp = ApplicationTemplates.find(app => app.type === PortalTrainingAppTemplate.type);
                if (homeApp) {
                    apps.push(homeApp);
                }
                if (trainingApp) {
                    //apps.push(trainingApp);
                }
                response.applications.forEach((value) => {
                    let target = ApplicationTemplates.find((app) => app.type === value.type);
                    if (!target) {
                        target = ApplicationTemplates.find((app) => app.type === "defaultApp");
                    }
                    target = { ...target, ...value };
                    if (target) {
                        apps.push(target);
                        target.onInitialized && target.onInitialized(target);
                    }
                    target.buttons?.forEach((item) => {
                        buttons.push(item);
                    });
                });
                apps.sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
                dispatch({ type: 'UPDATE_APPLICATIONS', payload: apps, shortcuts: buttons });
            }).catch(reason => {
                console.log(reason);
                if (reason.response.status === 401) {
                    console.log('redirect to /');
                    dispatch(push("/"));
                }
            });
            dispatch({ type: 'GET_APPLICATIONS' });
        }
    },
    getUserProfile: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        if (appState && !(appState.console?.userProfileState.isLoading ?? false)) {

           /* getUserPortalRoles(company, userId).then(response => {
                var response = JSON.parse(response);
                this.setState({
                    isRoot: response.root,
                    isAdmin: response.admin,
                    reportsAccess: response.reports,
                    portalAccess: response.access,
                    documentsAccess: response.documents,
                    isPermissionLoading: false,
                    Realm: company,
                    portalRolesVisible: true
                });
                )
            }*/


            getUserProfile().then((response: UserProfile) => {
                dispatch({ type: 'UPDATE_USER_PROFILE', payload: response });
            });
            dispatch({ type: 'GET_USER_PROFILE' });
        }
    },
    launchApplication: (payload: Application): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //dispatch({ type: 'UPDATE_LAUNCH_STATUS', payload: { isLaunching: true, application: payload } });
        if (payload.onLaunch) {
            payload.onLaunch(payload, dispatch);
        }
        else if (payload.launcher != null) {            
            dispatch({ type: 'UPDATE_LAUNCH_STATUS', payload: { isLaunching: true, application: payload } });
            window.open(payload.launcher as string);
            dispatch({ type: 'UPDATE_LAUNCH_STATUS', payload: { isLaunching: false, application: payload } });            
        }
    },
    setCurrentCompany: (payload: CurrentCompany): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: 'UPDATE_CURRENT_COMPANY', payload });
    },
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

const unloadedState: ConsoleState = {
    applicationsState: {
        isLoading: false,
        applications: [PortalHomeAppTemplate, PortalTrainingAppTemplate],
        buttons: [],
        currentCompany: {
            $id: '',
            domains: '',
            name: ''
        }
    },
    launchState: {
        isLaunching: false,
        application: ''
    },
    userProfileState: {
        isLoading: false,
        userProfile: {
            firstName: '',
            lastName: '',
            email: '',
            company: '',
            aspUserId: 0
        }
    }
};

export const reducer: Reducer<ConsoleState> = (state: ConsoleState | undefined, incomingAction: Action): ConsoleState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'GET_APPLICATIONS':
            return {
                ...state,
                applicationsState: {
                    ...state.applicationsState,
                    isLoading: true
                }
            };
        case 'UPDATE_APPLICATIONS':
            return {
                ...state,
                applicationsState: {
                    ...state.applicationsState,
                    applications: action.payload,
                    buttons: action.shortcuts,
                    isLoading: false
                }
            };
        case 'UPDATE_CURRENT_COMPANY':
            return {
                ...state,
                applicationsState: {
                    ...state.applicationsState,
                    currentCompany: action.payload
                }
            };
        case 'UPDATE_LAUNCH_STATUS':
            return {
                ...state,
                launchState: {
                    application: action.payload.application.name,
                    isLaunching: action.payload.isLaunching
                }
            }
        case 'GET_USER_PROFILE':
            return {
                ...state,
                userProfileState: {
                    ...state.userProfileState,
                    isLoading: true
                }
            };
        case 'UPDATE_USER_PROFILE':
            return {
                ...state,
                userProfileState: {
                    userProfile: action.payload,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};
